import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useGetAuthenticatedPortalSourcingEventsQuery } from "../../../../autogen/bff-api";
import { useDisplayDateWithTime } from "../../../../common/formatting/useDisplayDateWithTime";
import { urls } from "../../../../urls";
import { HomePanel } from "./HomePanel";
import { MutedCell, PanelRow, PanelTable, TitleCell } from "./PanelTable";

const DISPLAY_LIMIT = 6;

export const OpenProcurementsPanel = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const displayDateWithTime = useDisplayDateWithTime();

  const { data, isLoading, isError } = useGetAuthenticatedPortalSourcingEventsQuery({ limit: DISPLAY_LIMIT });
  const events = data?.events ?? [];

  return (
    <HomePanel titleKey="Open procurements" seeAllTo={urls.v2.supplier.procurements} isLoading={isLoading} isError={isError} isEmpty={events.length === 0} emptyKey="No open procurements right now">
      <PanelTable headers={[t("Title"), t("Buyer"), t("Deadline")]}>
        {events.map((event) => (
          <PanelRow key={event.id} onClick={() => navigate(urls.v2.supplier.procurement.go(event.id))}>
            <TitleCell title={event.title || t("Untitled")} />
            <MutedCell>{event.buyerName}</MutedCell>
            <MutedCell>
              {event.bidSubmissionDeadline ? displayDateWithTime(event.bidSubmissionDeadline) : "—"}
            </MutedCell>
          </PanelRow>
        ))}
      </PanelTable>
    </HomePanel>
  );
};
